(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["menu-dropdown"] && !Shopify.designMode) return;
  try {
    // Place la liste déroulante sous son entrée de menu, sans sortir de l'écran.
  (() => {
    const place = (event) => {
      const item = event.target.closest?.('.menu-list__list-item');
      const dropdown = item?.querySelector(':scope > .menu-list__submenu [data-menu-dropdown]');
      const trigger = item?.querySelector(':scope > .menu-list__trigger');
      const container = dropdown?.offsetParent;
      if (!dropdown || !trigger || !container) return;

      const containerRect = container.getBoundingClientRect();
      const maxLeft = containerRect.width - dropdown.offsetWidth - 16;
      const left = Math.max(0, Math.min(trigger.getBoundingClientRect().left - containerRect.left, maxLeft));
      dropdown.style.setProperty('--menu-dropdown-left', `${left}px`);
    };

    document.addEventListener('pointerover', place, { passive: true });
    document.addEventListener('focusin', place);
  })();
  } catch(e) { console.error(e); }
})();

})();
